import styled, { css } from 'styled-components';

export const DropdownToggler = styled.button`
  width: 100%;
  display: flex;
  background: transparent;
  border: none;
  justify-content: space-between;
  align-items: center;
  gap: 7px;
  color: #1B2A3D;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: box-shadow .3s;
  outline: none;
  border-radius: 4px;
  padding: 1px 0;

  img {
    transform: rotate(90deg);
  }

  ${({ $disabled }) => !$disabled && `
    &:focus,
    &:active {
      box-shadow: 0px 0px 0px 2px #D0E3ED;
    }
  `}

  ${({ $disabled }) => $disabled && `
    cursor: default;
  `}

  ${({ $empty }) => $empty && `
    color: #A3A3A3;
  `}
`;

export const DropdownButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  padding: 0;
  background: transparent;

  ${({ $secondary }) => $secondary && `
    color: #FF9900;
  `}

  svg {
    margin-right: 4px;
  }

  &:disabled {
    opacity: .5s;
  }
`;

export const ActionTick = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 5px;
  margin-left: 4px;
`;

export const ActionTickIcon = styled.img``;
